import React from "react";
import RoleGuard from "./roleGuard";

interface LevelRouteWrapperProps {
  levelData?: string | string[]; // Accepts a string, array, or undefined
  children: React.ReactElement;
}

const LevelRouteWrapper: React.FC<LevelRouteWrapperProps> = ({ levelData = [], children }) => {
  // Normalize levelData to always be an array
  const levels = Array.isArray(levelData) ? levelData : [levelData];

  return <RoleGuard allowedRoles={levels}>{children}</RoleGuard>;
};

export default LevelRouteWrapper;
